import React from 'react';
import { Modal, TFVButton, Translate } from '../../../Share/components';
import PropTypes from 'prop-types';
import { isIE } from '../../../Share/utils';
import { connect } from 'react-redux';
import { cancelLicense } from '../../actions';
import moment from 'moment';

function CancelLicense({
  isVisible = false,
  onClose = () => {},
  onCancelLicense = () => {},
  selectedLicense = {},
}) {
  const date = selectedLicense
    ? selectedLicense.DateFirstCancellationPossible
    : null;
  const displayDate = date ? moment(date).format('YYYY-MM-DD') : '';

  return (
    <Modal
      isVisible={isVisible}
      onCloseClicked={onClose}
      headerText="Avsluta"
      className="tv-cancel-license__modal"
      headerClassName="tv-create-license__modal-header"
      ieOptionClassName={isIE ? 'ie-fix-height' : ''}
    >
      <p className="mb-3">Är du säker på att du vill avsluta licensen?</p>
      <p className="mb-5">Avslutsdatum för licensen blir: {displayDate}</p>
      <div className="justify-content-between tv-display-flex gap-4 tv-cancel-license__modal__footer mt-5">
        <TFVButton
          type="line-primary"
          buttonType="button"
          className="w-50"
          text="Nej"
          onClick={onClose}
        />
        <TFVButton
          type="secondary"
          buttonType="button"
          className="w-50"
          text="Ja, avsluta"
          onClick={() => {
            onCancelLicense({
              licenseIdentifier: selectedLicense.LicenseIdentifier,
            });
            onClose();
          }}
        />
      </div>
    </Modal>
  );
}

CancelLicense.prototype = {
  isVisible: PropTypes.bool,
  onClose: PropTypes.func,
  onCancelLicense: PropTypes.func,
  selectedLicense: PropTypes.shape({}),
};

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({
  onCancelLicense: ({ licenseIdentifier }) => {
    dispatch(cancelLicense(licenseIdentifier));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CancelLicense);
